export const REGISTRATION_STATUS = "1" as const;
export const UPLOAD_STATUS = "2" as const;
export const PERSONAL_INFORMATION_STATUS = "3" as const;
export const CONTACT_ADDRESS_STATUS = "4" as const;
export const FINANCIAL_INFORMATION_STATUS = "5" as const;
export const TAX_RESIDENCY_INFORMATION_STATUS = "6" as const;
export const POLITICAL_EXPOSURE_INFORMATION_STATUS = "7" as const;
export const DOCUMENTATION_DELIVERY_INFORMATION_STATUS = "8" as const;
export const MARKETING_CONSENT_INFORMATION_STATUS = "9" as const;
export const SUMMARY_STATUS = "10" as const;
export const FINAL_STATUS = "11" as const;
